export default "__VITE_ASSET__bszU42Jn__"